export const strings = {
  english: {
    title: 'FREQUENTLY ASKED QUESTIONS',
    accordion1: {
      title: 'What are the system requirements for 360 WalkMix Creator™?',
      subtitle1: 'Windows',
      subtitle2: 'macOS',
      res1: 'Windows 8/8.1 64-bit (Standard and Pro Editions) or Windows 10 64-bit (Enterprise, Pro, or Home Editions)',
      res2: 'Intel Mac with macOS 10.13.6 or greater',
      res3: 'Intel® Core i5 processor, Intel® Core i7 or newer recommended',
      res4: '16GB RAM (32GB or more recommended)',
    },
    accordion2: {
      title: 'What Digital Audio Workstations (DAWs) are supported?',
      subtitle: 'The following Digital Audio Workstations (DAWs) are supported for 360 WalkMix Creator™:',
      li1: 'Pro Tools®',
      li2: 'Ableton Live™ 11',
      li3: 'Logic Pro®',
      li4: 'Cubase 11',
      li5: 'Nuendo 11',
      li6: 'Sequoia 16',
      li7: 'Studio One 5',
      li8: 'Reaper (VST only)',
      description: 'Please note that although other DAWs such as FL Studio or Bitwig are compatible with our plugin via VST3, they are not currently supported. Support will come in future versions. Feel free to try out 360 WalkMix Creator™ in these DAWs, but we cannot guarantee the robustness, performance, or feature parity with the DAWs mentioned in the list above. Also, not supported is HDX as a DSP.  Please refer to detailed operational requirements and system requirements for your specific DAW. ',
    },
    accordion3: {
      title: 'How do I add 360 WalkMix Creator™ to my session or project?',
      steps: ['First, add the plugin to a track:', 'Next, add the plugin to the output or master track:', 'Enable 360 WalkMix Creator™:'],
      li1: 'Add an instance of 360 WalkMix Creator™ plugin on one of the audio tracks in your project.',
      li2: 'If you do not have an audio track in your project, please add one at this time and then add 360 WalkMix Creator™ plugin to it.',
      li3: '360 WalkMix Creator™ plugin will launch.',
      li4: 'Feel free to close or move this instance of the plugin aside, as this is not the master. We will click “Yes, it is!” later.',
      li5: 'Add 360 WalkMix Creator™ plugin to the output/master track. Note: On some DAW’s this can be called “output” or “Stereo Output” and others, “master.”',
      li6: 'At this time, just add the plugin to your master track.',
      li7: 'A second 360 WalkMix Creator™ Plugin window will launch.',
      li8: 'Verify that you currently have the master/output selected in your DAW and Click on “Yes, it is!”',
      li9: 'This will set up your project so that you can monitor your output in a spatial format.',
    },
    accordion4: {
      title: 'How do I set up my environment for 360 WalkMix Creator™?',
      li1: 'To access 360 WalkMix Creator™ settings, click the settings icon.',
      li2: 'Click the Devices tab. Using the drop-down menus select and set the following: Output type, Output device, set the Sample rate to 48000, and set your Output buffer size.',
      li3: 'For Output type and Output device: Because this plugin has object audio rendering processing and can’t render output to the DAW due to bus constraints in DAW, render output should be connected to a DAC system to listen to 360 WalkMix Creator™ mix audio over loudspeakers.',
      li4: 'Depending upon the capabilities of your system, please choose an Output buffer size of 1,024 or greater, keeping in mind that multiples of 512 are preferable. For example, 1024. If you find that the audio stutters during normal operation, please increase your buffer size further.',
      p: 'Please see your specific DAW manufacturer guidelines for instructions on how to add a plugin.',
    },
    buyNow: {
      title: 'WORKS THE WAY YOU WORK.',
      hero: '360 WalkMix Creator™ integrates into your current workflows and tools including remote ones. Designed to integrate into your existing non-linear or linear workflows.',
      button: 'BUY NOW',
      product: 'GO TO MY PRODUCTS',
    },
  },
  japan: {
    title: 'よくある質問',
    accordion1: {
      title: '360 WalkMix Creator™のシステム環境は？',
      subtitle1: 'Windows',
      subtitle2: 'macOS',
      res1: 'Windows 10 64-ビット(Enterprise、ProまたはHomeエディション)',
      res2: 'Intel Mac、macOS 10.13.6 以降',
      res3: 'Intel Core i5、Intel Corei7以降推奨',
      res4: '16GB RAM 、32GB以上推奨',
      res5: 'Microsoft Windows® Windows 8/8.1 64-ビット(Standard、またはProエディション)',
    },
    accordion2: {
      title: 'どのデジタルオーディオワークステーション(DAW)で使用できますか?',
      subtitle: '下記に記されたDAW(デジタルオーディオワークステーション)は360 WalkMix Creator™:に対応しています。',
      li1: 'Pro Tools®',
      li2: 'Ableton Live™ 11',
      li3: 'Logic Pro®',
      li4: 'Cubase 11',
      li5: 'Nuendo 11',
      li6: 'Sequoia 16',
      li7: 'Studio One 5',
      li8: 'Reaper (VST only)',
      description: 'ご注意: Bitwig, Ardour や FL Studio、VST3 に対応するその他の DAW においても 360 WalkMix Creator™ プラグインと互換性がありますが、現在はこれらの製品における安定したパフォーマンス、上記の現在対応している DAW と同等の動作は保証されていません。今後のアップデートにおいて追加される予定です。360 WalkMix Creator™をこれらの DAW で試用することは可能ですが、最大パフォーマンス、上記の機能が正常に動作することは保証されていません。また、DSP として HDX は対応していません。機器の設定に関する詳細はお使いの DAW の取扱説明書を参照して下さい。',
    },
    accordion3: {
      title: "'どのような手順で360 WalkMix Creator™を楽曲に追加したら良いでしょうか？",
      steps: ['まず、トラックにプラグインを追加します。', '次に360 WalkMix Creator™プラグインを出力、またはマスタートラックに追加します。', '360 WalkMix Creator™を有効にする：'],
      p1: '360 WalkMix Creator™をプロジェクトのオーディオトラックのひとつに追加します。',
      p2: 'プロジェクトにオーディオトラックがない場合は、360 WalkMix Creator™プラグインを追加してください。360 WalkMix Creator™プラグインが起動します。このプラグインで表示される"Yes, it is!”ボタンはまだ、クリックしないでください。',
      p3: '360 WalkMix Creator™プラグインを出力、またはマスタートラックに追加します。DAWによって、Output(出力)、Stereo Output(ステレオ出力)、Master(マスター)などと表示されていることもあります。この時は、マスタートラックにプラグインを追加します。2つ目の360 WalkMix Creator™プラグインの画面が開きます。',
      p4: '出力、またはマスターがDAW内で選択されていることを確認し、“Yes, it is!”をクリックします。以上の手順にて、オーディオが360 Reality Audioミキシングプロジェクト内のオブジェクトとして表示されます。',
    },
    accordion4: {
      title: "'360 WalkMix Creator™をセットアップするには？",
      p1: '360 WalkMix Creator™の設定をするには、まず“Settings(設定)”アイコンをクリックしてください。次に”Devices(デバイス)”タブをクリックし、プルダウンメニューからそれぞれ、Output Type(出力タイプ)、Output Device(出力デバイス)を選択してください。',
      p2: 'Sample Rate(サンプリングレート)を48000Hzに設定し、Output Buffer(出力バッファーサイズ)を設定してください。',
      p3: '出力タイプ、出力デバイス に関して: このプラグインは360 Reality Audioにレンダリングして再生します。レンダリングされた再生音はDAWで設定されたアウトプットを使用しないため、スピーカーで再生音をモニタリングするためには、プラグインの出力をスピーカーが接続されているDACシステムに接続する必要があります。楽曲を再生するにはレンダリング出力はDACシステムに接続されている必要があります。',
      p4: 'お使いのシステムに合わせて、出力バッファサイズ(Output buffer)を512またはそれ以上を選択して下さい。1024等、512の倍数が推奨されています。オーディオが途切れてしまう場合は、バッファサイズを大きくしてください。',
    },
    accordion5: {
      title: '360 WalkMix Creator™を使ってどのようにオブジェクトを操作しますか?',
      p1: 'オブジェクトをクリックし、既存のグループにドラッグするだけでオブジェクトのグループを変更できます。同様の方法で、グループ間のオブジェクト移動ができます。オブジェクトやグループの色を変えるには、色を変更したいグループもしくはオブジェクトを選択し、“Property”画面で”Color“をクリックしてください。',
      p2: '“3D View”、もしくは他の視点で表示されたビュー内でオブジェクトをクリックし、お好きな場所にドラッグできます。オブジェクトやオブジェクトグループは、ビューポートのアイコン、もしくはオブジェクトリストから選択でき、高さ方向の“Elevation”や横方向の”Azimuth“のパラメータをドラッグすることで１つ１つのオブジェクトに対して微調整が行えます。オブジェクトやグループを選択し、Property画面でこれらのパラメータやGainをクリックしながら上下にドラッグ、または直接値を入力すると、より正確に数値を変更できます。',
    },
    buyNow: {
      title: '思い通りの音楽制作を実現',
      hero: '360 WalkMix Creator™はこれまでの音楽制作の流れと使用してきたツールを融合し、スタジオ外などで制作したちょっとしたオーディオも全て作品に融合できるように設計されています。',
      button: '購入する',
      product: 'GO TO MY PRODUCTS',
    },
  },
};
